import React, { useState, useEffect } from 'react';
import { Phone, Instagram, Menu, X } from 'lucide-react';
import { engineerInfo } from '../../mock';
import { Button } from '../ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#073A40] shadow-lg' 
          : 'bg-[#073A40]/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <div className="flex items-center">
            <div className="text-white">
              <h1 className="text-base sm:text-xl lg:text-2xl font-bold leading-tight">
                {engineerInfo.name}
              </h1>
              <p className="text-xs sm:text-sm lg:text-base text-[#A69F97]">{engineerInfo.title}</p>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-4 lg:space-x-6">
            <button 
              onClick={() => scrollToSection('servicos')}
              className="text-[#F2F2F2] hover:text-[#A69076] transition-all duration-300 text-base font-semibold hover:scale-105"
            >
              Serviços
            </button>
            <button 
              onClick={() => scrollToSection('depoimentos')}
              className="text-[#F2F2F2] hover:text-[#A69076] transition-all duration-300 text-base font-semibold hover:scale-105"
            >
              Avaliações
            </button>
            <button 
              onClick={() => scrollToSection('contato')}
              className="text-[#F2F2F2] hover:text-[#A69076] transition-all duration-300 text-base font-semibold hover:scale-105"
            >
              Contato
            </button>
          </nav>

          <div className="hidden md:flex items-center space-x-3 ml-4">
            <a 
              href={engineerInfo.instagramLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F2F2F2] hover:text-[#A69076] transition-all duration-300 hover:scale-110"
              aria-label="Instagram"
            >
              <Instagram size={22} />
            </a>
            <Button 
              asChild
              className="bg-[#A69076] hover:bg-[#A69F97] text-[#073A40] font-semibold transition-all duration-300 text-sm lg:text-base hover:scale-105"
            >
              <a href={engineerInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                <Phone size={16} className="mr-2" />
                <span className="hidden lg:inline">Fale Conosco</span>
                <span className="lg:hidden">WhatsApp</span>
              </a>
            </Button>
          </div>

          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#A69F97]/20">
            <nav className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('servicos')}
                className="text-[#F2F2F2] hover:text-[#A69076] transition-colors text-sm font-medium text-left py-2"
              >
                Serviços
              </button>
              <button 
                onClick={() => scrollToSection('depoimentos')}
                className="text-[#F2F2F2] hover:text-[#A69076] transition-colors text-sm font-medium text-left py-2"
              >
                Avaliações
              </button>
              <button 
                onClick={() => scrollToSection('contato')}
                className="text-[#F2F2F2] hover:text-[#A69076] transition-colors text-sm font-medium text-left py-2"
              >
                Contato
              </button>
              <div className="flex flex-col gap-3 pt-2 border-t border-[#A69F97]/20">
                <Button 
                  asChild
                  className="bg-[#A69076] hover:bg-[#A69F97] text-[#073A40] font-semibold w-full"
                >
                  <a href={engineerInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
                    <Phone size={16} className="mr-2" />
                    WhatsApp
                  </a>
                </Button>
                <a 
                  href={engineerInfo.instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#F2F2F2] hover:text-[#A69076] transition-colors flex items-center justify-center gap-2 py-2"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                  <span className="text-sm">Siga no Instagram</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
